/* Cross-sell: after either personalized Biothane 38mm collar is added to
 * cart, show a popup offering the matching colored Cobra buckle (+10 zl).
 *
 * Hooks into the same cart-update pubsub event product-form.js publishes
 * right after a successful add-to-cart, and reuses the active cart UI's own
 * getSectionsToRender()/renderContents() so the buckle shows up the same way
 * a normal add-to-cart would, whether the theme is set to cart-notification
 * or cart-drawer.
 */
(function () {
  'use strict';
  if (window.__klamraUpsellJs) return;
  window.__klamraUpsellJs = true;

  var COLLAR_IDS = [16479810421081, 16666483097945];

  var modal, overlay, closeBtn, skipBtn, colorButtons, statusEl;

  function init() {
    modal = document.getElementById('KlamraUpsellModal');
    if (!modal) return;

    overlay = modal.querySelector('.klamra-upsell-modal__overlay');
    closeBtn = modal.querySelector('.klamra-upsell-modal__close');
    skipBtn = modal.querySelector('.klamra-upsell-modal__skip');
    statusEl = modal.querySelector('.klamra-upsell-modal__status');
    colorButtons = Array.prototype.slice.call(modal.querySelectorAll('.klamra-upsell-modal__color'));

    overlay.addEventListener('click', hideModal);
    closeBtn.addEventListener('click', hideModal);
    skipBtn.addEventListener('click', hideModal);
    modal.addEventListener('keyup', function (event) {
      if (event.code === 'Escape') hideModal();
    });

    colorButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        addKlamra(btn.dataset.variantId);
      });
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function (event) {
        if (event.source !== 'product-form') return;
        var cartData = event.cartData;
        if (!cartData) return;
        var addedProductId = cartData.product_id;
        if (COLLAR_IDS.indexOf(addedProductId) === -1) return;
        setTimeout(showModal, 450);
      });
    }
  }

  function getCartUIElement() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function showModal() {
    resetButtons();
    modal.hidden = false;
    requestAnimationFrame(function () {
      modal.classList.add('is-open');
    });
  }

  function hideModal() {
    modal.classList.remove('is-open');
    setTimeout(function () {
      modal.hidden = true;
    }, 250);
  }

  function resetButtons() {
    colorButtons.forEach(function (b) {
      b.disabled = false;
    });
    statusEl.hidden = true;
    statusEl.textContent = '';
  }

  function setStatus(text) {
    statusEl.hidden = false;
    statusEl.textContent = text;
  }

  function addKlamra(variantId) {
    colorButtons.forEach(function (b) {
      b.disabled = true;
    });
    setStatus('Dodaję do koszyka…');

    var cartEl = getCartUIElement();

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);
    if (cartEl) {
      formData.append(
        'sections',
        cartEl.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
    }

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status) {
          setStatus('Nie udało się dodać klamry. Spróbuj ponownie.');
          colorButtons.forEach(function (b) {
            b.disabled = false;
          });
          return;
        }

        if (cartEl && typeof cartEl.setActiveElement === 'function') {
          cartEl.setActiveElement(document.activeElement);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'klamra-upsell', cartData: data });
        }

        if (cartEl && typeof cartEl.renderContents === 'function') {
          cartEl.renderContents(data);
        }

        setStatus('Dodano! 🎉');
        setTimeout(hideModal, 600);
      })
      .catch(function () {
        setStatus('Nie udało się dodać klamry. Spróbuj ponownie.');
        colorButtons.forEach(function (b) {
          b.disabled = false;
        });
      });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
